module.exports = __webpack_public_path__ + "static/media/Clarificador.46fe6939.png";